module.exports = __webpack_public_path__ + "img/Real World Sharp Shooter Locked.8235d3b.png";